import { useEffect } from 'react';

interface StructuredDataProps {
  type: 'WebPage' | 'Organization' | 'Product' | 'ContactPage' | 'AboutPage' | 'ItemList';
  data: Record<string, unknown>;
}

const StructuredData = ({ type, data }: StructuredDataProps) => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
    
    const baseData: Record<string, unknown> = {
      '@context': 'https://schema.org',
      '@type': type,
      url: `${siteUrl}${window.location.pathname}`,
    };

    const structuredData = {
      ...baseData,
      ...data,
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    script.id = `structured-data-${type}`;
    
    const existingScript = document.getElementById(`structured-data-${type}`);
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(`structured-data-${type}`);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data]);

  return null;
};

export default StructuredData;